import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxListMessageOptions } from "./dx-list-message-options";
import { DxListToolbarOptions } from "./toolbar/dx-list-toolbar-options";
let DxListOptions = class DxListOptions {
    constructor() {
        this._allowMultiSelect = false;
        this._selectNextAfterRemove = true;
        this._showToolbar = false;
        this._showSearchBox = false;
        this._externalToolbarHandler = false;
        this._useModalForEdit = false;
        /** показывать описание второй строкой списка */
        this._showDescription = false;
    }
    /*@jsonMember({ elements: TaskListFilter, name: "filters", emitDefaultValue: false, isRequired: false })
    protected _filters: TaskListFilter[];
  
    @jsonMember({ elements: TaskListSort, name: "sorts", emitDefaultValue: false, isRequired: false })
    protected _sorts: TaskListSort[];*/
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get ident() {
        return this._ident;
    }
    get dataSourceIdent() {
        return this._dataSourceIdent;
    }
    set dataSourceIdent(value) {
        this._dataSourceIdent = value;
    }
    get dataProviderFactoryIdent() {
        return this._dataProviderFactoryIdent;
    }
    set dataProviderFactoryIdent(value) {
        this._dataProviderFactoryIdent = value;
    }
    get actionResolverIdent() {
        return this._actionResolverIdent;
    }
    set actionResolverIdent(value) {
        this._actionResolverIdent = value;
    }
    get modalsProviderIdent() {
        return this._modalsProviderIdent;
    }
    set modalsProviderIdent(value) {
        this._modalsProviderIdent = value;
    }
    set ident(value) {
        this._ident = value;
    }
    get allowMultiSelect() {
        return this._allowMultiSelect;
    }
    set allowMultiSelect(value) {
        this._allowMultiSelect = value;
    }
    get selectNextAfterRemove() {
        return this._selectNextAfterRemove;
    }
    set selectNextAfterRemove(value) {
        this._selectNextAfterRemove = value;
    }
    get showToolbar() {
        return this._showToolbar;
    }
    set showToolbar(value) {
        this._showToolbar = value;
    }
    get externalToolbarHandler() {
        return this._externalToolbarHandler;
    }
    set externalToolbarHandler(value) {
        this._externalToolbarHandler = value;
    }
    get showSearchBox() {
        return this._showSearchBox;
    }
    set showSearchBox(value) {
        this._showSearchBox = value;
    }
    get noDataMessageOptions() {
        return this._noDataMessageOptions;
    }
    set noDataMessageOptions(value) {
        this._noDataMessageOptions = value;
    }
    get errorMessageOptions() {
        return this._errorMessageOptions;
    }
    set errorMessageOptions(value) {
        this._errorMessageOptions = value;
    }
    get toolbar() {
        return this._toolbar;
    }
    set toolbar(value) {
        this._toolbar = value;
    }
    get useModalForEdit() {
        return this._useModalForEdit;
    }
    set useModalForEdit(value) {
        this._useModalForEdit = value;
    }
    get showDescription() {
        return this._showDescription;
    }
    set showDescription(value) {
        this._showDescription = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxListOptions.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListOptions.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListOptions.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dataSourceIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListOptions.prototype, "_dataSourceIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dataProviderFactoryIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListOptions.prototype, "_dataProviderFactoryIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "actionResolverIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListOptions.prototype, "_actionResolverIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "modalsProviderIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListOptions.prototype, "_modalsProviderIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "allowMultiSelect", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListOptions.prototype, "_allowMultiSelect", void 0);
tslib_1.__decorate([
    jsonMember({ name: "selectNextAfterRemove", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListOptions.prototype, "_selectNextAfterRemove", void 0);
tslib_1.__decorate([
    jsonMember({ name: "showToolbar", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListOptions.prototype, "_showToolbar", void 0);
tslib_1.__decorate([
    jsonMember({ name: "showSearchBox", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListOptions.prototype, "_showSearchBox", void 0);
tslib_1.__decorate([
    jsonMember({ name: "externalToolbarHandler", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListOptions.prototype, "_externalToolbarHandler", void 0);
tslib_1.__decorate([
    jsonMember({ name: "noDataMessageOptions", constructor: DxListMessageOptions, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxListMessageOptions)
], DxListOptions.prototype, "_noDataMessageOptions", void 0);
tslib_1.__decorate([
    jsonMember({ name: "errorMessageOptions", constructor: DxListMessageOptions, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxListMessageOptions)
], DxListOptions.prototype, "_errorMessageOptions", void 0);
tslib_1.__decorate([
    jsonMember({ name: "toolbar", constructor: DxListToolbarOptions, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxListToolbarOptions)
], DxListOptions.prototype, "_toolbar", void 0);
tslib_1.__decorate([
    jsonMember({ name: "useModalForEdit", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListOptions.prototype, "_useModalForEdit", void 0);
tslib_1.__decorate([
    jsonMember({ name: "showDescription", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListOptions.prototype, "_showDescription", void 0);
DxListOptions = tslib_1.__decorate([
    jsonObject
], DxListOptions);
export { DxListOptions };
